var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStars45(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 18,
    viewBox: "0 0 97 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_197_332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0388 0H0V18H18.0388V0Z",
    fill: "#00B67A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5808 0H19.5421V18H37.5808V0Z",
    fill: "#00B67A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1228 0H39.084V18H57.1228V0Z",
    fill: "#00B67A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6649 0H58.6261V18H76.6649V0Z",
    fill: "#00B67A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2069 0H87.1875V18H96.2069V0Z",
    fill: "#DCDCE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1875 0H78.1681V18H87.1875V0Z",
    fill: "#00B67A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01939 12.1313L11.7628 11.4376L12.909 14.9626L9.01939 12.1313ZM15.333 7.5751H10.5038L9.01939 3.0376L7.53495 7.5751H2.70581L6.61422 10.3876L5.12977 14.9251L9.03818 12.1126L11.4433 10.3876L15.333 7.5751Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5614 12.1313L31.3048 11.4376L32.4511 14.9626L28.5614 12.1313ZM34.875 7.5751H30.0459L28.5614 3.0376L27.077 7.5751H22.2479L26.1563 10.3876L24.6718 14.9251L28.5802 12.1126L30.9854 10.3876L34.875 7.5751Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1034 12.1313L50.8468 11.4376L51.9931 14.9626L48.1034 12.1313ZM54.417 7.5751H49.5879L48.1034 3.0376L46.619 7.5751H41.7899L45.6983 10.3876L44.2138 14.9251L48.1222 12.1126L50.5274 10.3876L54.417 7.5751Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6455 12.1313L70.3889 11.4376L71.5351 14.9626L67.6455 12.1313ZM73.9591 7.5751H69.1299L67.6455 3.0376L66.161 7.5751H61.3319L65.2403 10.3876L63.7559 14.9251L67.6643 12.1126L70.0694 10.3876L73.9591 7.5751Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1875 12.1313L89.9309 11.4376L91.0771 14.9626L87.1875 12.1313ZM93.5011 7.5751H88.6719L87.1875 3.0376L85.703 7.5751H80.8739L84.7823 10.3876L83.2979 14.9251L87.2063 12.1126L89.6114 10.3876L93.5011 7.5751Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_197_332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96.2069,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars45);
export default __webpack_public_path__ + "static/media/stars-4.5.7374ee392cc7fbca6b2723afc5b14242.svg";
export { ForwardRef as ReactComponent };